import { isPresent } from 'utils'
import Limitations from 'features/Limitations'

const {
  CAMPAIGN_MAX_AD_GROUPS,
  AD_GROUP_MAX_KEYWORDS,
  AD_GROUP_MAX_CREATIVES,
  MAX_IMAGE_LIBRARIES,
} = Limitations

export const errorMessages = {
  // http
  400: '잘못된 요청을 보냈습니다.',
  404: '데이터가 존재하지 않습니다.',
  401: '인증에 실패했습니다.',
  403: '권한이 없습니다.',

  100000: '유효하지 않은 URL 형식입니다.',
  100001: '비즈채널의 URL에 적합하지 않은 랜딩 URL입니다.',

  // create biz channel
  101001: '업종 카테고리가 입력되지 않았습니다.',
  101002: '기 등록된 비즈채널명이 있습니다.',
  101003: '비즈채널 이름이 올바르지 않습니다.',
  101004: '비즈채널 이름은 2~12글자 이내여야 합니다.',
  101005: '유효하지 않은 PC URL입니다.',
  101006: '유효하지 않은 모바일 URL입니다.',
  101007: '이미 존재하는 PC URL입니다.',
  101008: '이미 존재하는 모바일 URL입니다.',
  101010: '테스트 아이디와 비밀번호가 입력되지 않았습니다.',
  101011: '유효하지 않은 업종입니다.',
  101012: '비즈채널이 존재하지 않습니다.',
  101013: '비즈채널이 정지되었습니다.',
  101014: '연동된 캠페인이 존재합니다.',
  101015: '연동 가능한 최대 카카오톡 채널 갯수를 초과하였습니다.',
  101016: '업종에 맞는 심사서류가 아닙니다.',
  101017: '이미 카카오톡 채널계정이 연동되어 있습니다.',
  101018: '잘못된 심사상태입니다.',
  101019: '비즈채널 최대갯수 초과입니다.',
  101020: 'PC 또는 모바일 사이트를 입력하세요.',
  101021: 'PC 사이트 설정은 변경할 수 없습니다.',
  101022: '모바일 사이트 설정은 변경할 수 없습니다.',
  101023: '심사 서류가 등록되지 않았습니다.',
  101024: '비즈채널의 URL 설정 체계에 정상적으로 입력하세요.',

  101100: '현재 비즈채널 심사상태에서는 심사사유가 존재하지 않습니다.',

  // SiteUrl Connection
  102001: '잘못된 URL입니다.',
  102002: '해당 사이트는 접속이 차단되었습니다.',
  102003: '잘못된 카카오톡 채널입니다.',
  102004: '카카오톡 채널 서비스를 사용할 수 없습니다.',
  102005: 'URL은 최대 1,000자까지 입력가능합니다',
  102006:
    'URL은 한글/영문/숫자와 특수문자 $-_.+!*\'"(){}|^~[]`<>#%;/?:@&= 만 입력하세요.',

  // campaign
  103000: '캠페인 유형에 유효하지 않은 비즈채널입니다.',
  103001: '캠페인 최대갯수 초과입니다.',
  103002: '캠페인 이름 중복입니다.',
  103003: '캠페인 이름 길이 초과 또는 미만입니다.',
  103004: '캠페인 일예산 초과 또는 미만입니다.',
  103005: '없는 비즈채널입니다.',
  103006: '비즈채널 권한이 없습니다.',
  103007: 'Pixel&SDK 권한이 없습니다.',
  103008: '캠페인이 존재하지 않습니다.',
  103009: '캠페인이 존재하지 않습니다.',

  // adgroup
  104000: '제외키워드는 100개까지 등록 가능합니다.',
  104001:
    '일예산을 지정했을 경우, 최소 1,000원, 최대 10,000,000원 범위 내에서 10원 단위로 등록 가능합니다.',
  104002: `캠페인당 광고그룹은 최대 ${CAMPAIGN_MAX_AD_GROUPS}개까지만 등록이 가능합니다.`,
  104003: '같은 캠페인 내에 중복된 이름의 광고그룹이 존재합니다.',
  104004: '광고그룹명은 최소 1자, 최대 50자까지 입력 가능합니다.',
  104005: '해당 캠페인이 존재하지 않습니다.',
  104006: '해당 캠페인을 소유하고 있지 않습니다.',
  104007: '이미 삭제된 그룹은 수정할 수 없습니다.',
  104008: '유효하지 않은 게재지면 선택입니다.',
  104009: '유효하지 않은 디바이스 설정입니다.',
  104010: '해당 광고그룹이 존재하지 않습니다.',
  104011:
    '제외키워드에 입력 불가능한 문자가 입력되어 있습니다. (특수문자 일부, 한자 입력 불가능)',
  104012: '제외키워드는 1자이상 50자 이하여야 합니다.',
  104013: '복사할 광고그룹을 1개이상 선택해야 합니다.',
  104014: '복사할 광고그룹을 10개이하로 선택해야 합니다.',
  104015: '비즈채널이 같은 캠페인으로만 광고그룹 복사가 가능합니다.',
  104016: '이미 복사가 진행되고 있는 광고그룹이 포함되어 있습니다.',
  104017: '해당 광고그룹 복사 내역이 존재하지 않습니다.',
  104018: '이미 삭제된 광고그룹 복사 내역입니다.',
  104019: '해당 광고그룹의 복사를 재시도할 수 없습니다.',

  104200:
    '노출 종료날짜 선택시, 종료날짜는 시작날짜를 앞서서 등록할 수 없습니다.',
  104201: '광고가 노출될 수 있는 스케쥴을 최소 1개 이상 등록해야 합니다.',
  104202:
    '스케쥴은 정수 7개를 스페이스로 분리하여 문자열로 만들어서 등록해야 합니다.',
  104203: '이전 날짜는 등록할 수 없습니다.',

  104100:
    '직접설정 입찰가는 최소 70원, 최대 100,000원 범위 내에서 10원 단위로 등록 가능합니다.',
  104101:
    '콘텐츠 매체 입찰가 선택시, 입찰가는 최소 78원, 최대 100,000원 범위 내에서 10원 단위로 등록 가능합니다. ',
  104102: 'PC 입찰 가중치는 최소 10%, 최대 500% 범위 내에서 등록 가능합니다.',
  104103:
    '모바일 입찰 가중치는 최소 10%, 최대 500% 범위 내에서 등록 가능합니다.',
  104104:
    '키워드 확장 입찰 가중치는 최소 10%, 최대 500% 범위 내에서 등록 가능합니다.',

  // keyword
  105000: '이미 삭제된 키워드는 수정할 수 없습니다.',
  105001: '키워드는 1자~50자 범위 내에서 입력하세요.',
  105002: '키워드는 한글, 영문, 숫자만 가능합니다.',
  105003: '잘못된 키워드 랜딩 URL입니다.',
  105004: `그룹당 최대 ${AD_GROUP_MAX_KEYWORDS}개의 키워드를 등록할 수 있습니다.`,
  105005: '등록 키워드를 1개이상 입력하셔야 합니다.',
  105006: '구매 불가능한 키워드가 포함되어있습니다.',
  105007: '해당 금지키워드가 존재하지 않습니다.',
  105008: '금지 키워드를 1개이상 입력하셔야 합니다.',
  105009: '해당 그룹에 키워드가 이미 등록되어 있습니다.',
  105010: '키워드가 존재하지 않습니다.',
  105011: '비즈채널이 같은 그룹으로만 키워드 복사가 가능합니다.',
  105012: '광고계정내 등록 가능한 키워드 개수가 초과 되었습니다.',

  105100:
    '직접설정 입찰가는 최소 70원, 최대 100,000원 범위 내에서 10원 단위로 등록 가능합니다.',
  105101:
    '희망순위 한도액은 최소 70원, 최대 100,000원 범위 내에서 10원 단위로 등록 가능합니다.',
  105102: '희망순위는 1위 이상이어야 합니다.',

  105200: '유효하지 않은 키워드 랜딩 URL입니다.',
  105201: '키워드 랜딩 URL 복사 중 오류가 발생했습니다.',
  105202: '키워드 랜딩 URL은 심사중에 수정할 수 없습니다.',
  105203: '비즈채널의 URL에 적합하지 않은 키워드 랜딩 URL입니다.',

  105300: '현재 키워드 심사상태에서는 심사사유가 존재하지 않습니다.',

  // creative
  106000: '소재에 유효하지 않은 비즈채널입니다.',
  106001: '소재 최대갯수 초과입니다.',
  106002: '소재 이름 중복입니다.',
  106003: '소재 이름 길이 초과 또는 미만입니다.',
  106004: '유효하지 않은 랜딩URL입니다.',
  106005: '의료광고심의필번호 또는 심의서류를 입력하세요.',
  106006:
    '의료광고 심의대상은 비즈채널 카테고리가 건강_병원 업종이여야 합니다..',
  106007: '심사 서류가 유효하지 않습니다.',
  106008: '소재가 존재하지 않습니다.',
  106009: '현재 소재 심사상태에서는 심사사유가 존재하지 않습니다.',

  // creative text
  106100: '타이틀 길이 초과 또는 미만입니다.',
  106101: '설명 길이 초과 또는 미만입니다.',
  106102: '추가제목 길이 초과 또는 미만입니다.',
  106103: '부가링크 갯수 초과 또는 미만입니다.',
  106104: '부가링크 설명 길이 초과 또는 미만입니다.',
  106105: '말머리 길이 초과 또는 미만입니다.',
  106106: '가격테이블 갯수 초과 또는 미만입니다.',
  106107: '가격테이블 설명 길이 초과 또는 미만입니다.',
  106108: '유효하지 않은 말머리입니다.',
  106109: '유효하지 않은 수식입니다.',
  106110:
    '가격테이블 가격은 최소 0원, 최대 999,999,999원 범위 내에서 등록 가능합니다.',

  // creative image
  106200: '유효하지 않은 이미지URL입니다.',
  106201: '이미지 설명문구 길이 초과 또는 미만입니다.',
  106202: '썸네일 이미지 사이즈가 아닙니다.',
  106203: '멀티썸네일 이미지 갯수 초과 또는 미만입니다.',

  // creative button
  106300: '잘못된 전화번호 형식입니다.',
  106301: '해당 업종은 계산하기 URL을 사용할 수 없습니다.',

  // creative link
  106400: '카카오 뱃지가 유효하지 않습니다.',
  106401: '톡채널이 유효하지 않습니다.',

  // creative native
  106500: '네이티브 프로필 이미지 사이즈가 아닙니다.',
  106501: '네이티브 프로모션 이미지 사이즈가 아닙니다.',
  106502: '네이티브 프로필이름 길이 초과 또는 미만입니다.',
  106503: '네이티브 타이틀 길이 초과 또는 미만입니다.',
  106504: '네이티브 프로모션 길이 초과 또는 미만입니다.',
  106505: '유효하지 않은 네이티브 행동유도버튼입니다.',

  // restrictionIp
  107000: '잘못된 IP 주소입니다.',
  107001: '설명 길이 초과 또는 미만입니다.',
  107002: '제한 IP 중복입니다.',
  107003: '제한 IP 최대갯수 초과입니다.',
  107100: '키워드, 소재 탭 조회 시 캠페인 하나를 필수로 선택해주세요.',

  // creativeLink
  108000: '이미 그룹 안에서 삭제된 소재는 수정할 수 없습니다.',
  108001: `그룹당 최대 ${AD_GROUP_MAX_CREATIVES}개의 소재를 등록할 수 있습니다.`,
  108002: '이미 그룹에 존재하는 소재를 다시 등록할 수 없습니다.',
  108003: '소재의 비즈채널이 광고그룹의 비즈채널과 맞지 않습니다.',
  108004: '등록할 소재를 1개 이상 입력해야 합니다.',

  // metricsColumnSetting
  109000: '열맞춤설정 최대갯수 초과입니다.',
  109001: '열맞춤설정 이름 중복입니다.',
  109002: '열맞춤설정 이름 길이 초과 또는 미만입니다.',

  // customReport
  110000: '맞춤보고서 이름 중복입니다.',
  110001: '맞춤보고서 이름 길이 초과 또는 미만입니다.',
  110002: '맞춤보고서 조회단위에 맞게 필터 옵션을 선택해야 합니다.',
  110003: '맞춤보고서 기간 설정이 유효하지 않습니다.',
  110004: '맞춤보고서 분석항목이 유효하지 않습니다.',

  // history
  201001: '변경이력 조회 기간이 잘못되었습니다.',

  // adAccount
  111000: '광고 계정을 찾을 수 없습니다.',
  111001: 'DSP 계정을 찾을 수 없습니다.',
  111002: 'DSP 계정이 잘못되었습니다.',

  // dsp image
  112000: '유효하지 않은 이미지 URL입니다',
  112001: '한번에 추가할 수 있는 이미지는 100개입니다.',
  112002: `계정당 추가할 수 있는 이미지는 ${MAX_IMAGE_LIBRARIES}개입니다.`,
  112003: '이미지 관리에 없는 이미지 입니다.',
  112004: '이미지 관리에서 삭제된 이미지를 사용할 수 없습니다.',
  112005: '해당 이미지를 소유하고 있지 않습니다.',
  112006: '이미지 URL 길이 초과 또는 미만입니다.',
  112007: '이미지 파일명 길이 초과 또는 미만입니다.',

  // KEYWORDAD-1664
  501001: '허용되지 않은 확장자 입니다.',
  501002: '허용되지 않은 파일 경로 입니다.',
}

export const getErrorMessage = (
  error,
  {
    defaultMessage = '알 수 없는 에러가 발생했습니다',
    messageMap = errorMessages,
  } = {}
) => {
  if (!isPresent(error)) return defaultMessage
  if (typeof error === 'string') return error
  const errorCode = error.isAxiosError
    ? error?.response?.data?.errorCode || error?.response?.status
    : error?.errorCode || error?.status
  return messageMap[errorCode] || defaultMessage
}
